import request from '@utils/request'
import gateway from '@enum/gateway'

const getWechatAppIds = params => {
  return request.fetch(gateway.channel + '/v1/weixin/record/list/auth', params)
}
// 企业信息
const getCompanyInfo = params => {
  return request.fetch(gateway.tenant + '/v1/basic/tenant/merchant/get', params)
}
const saveCompanyInfo = params => {
  return request.put(
    gateway.tenant + '/v1/basic/tenant/merchant/update',
    params
  )
}
// 获取公众号列表
const getWechatAppList = params => {
  return request.fetch(gateway.channel + '/v1/weixin/record/authAppids', params)
}
// 获取品牌列表
const getBrandList = params => {
  return request.fetch(gateway.tenant + '/v1/brandPrivilege/user/auth', {
    ...params,
    bcGroup: '9b170abb-407b-4f0b-85f8-cb5a70f89622'
  })
}
export {
  getWechatAppIds,
  getCompanyInfo,
  saveCompanyInfo,
  getWechatAppList,
  getBrandList
}
